export function lineBreaker( string ) {
  try {
    const maxChars = 55;
    const stringLines = [[]];
    let currentStringLine = 0;

    let stringSoFar = '';
    const stringThrough = string.split( ' ' );

    const breakLine = ( key, remainingWord = null ) => {
        stringLines[ currentStringLine ].push( stringSoFar );
        currentStringLine += 1;
        stringSoFar = '';
        
        if( key != stringThrough.length - 1 ){
            stringLines[ currentStringLine ] = [];
        }

        if( remainingWord ) {
            stringSoFar += stringThrough[ key ];
            if( key === stringThrough.length - 1 ) {
                stringLines[ currentStringLine ] = [ stringSoFar ];
            }
        }
    };


    for( let key = 0; key < stringThrough.length; key ++ ) {
        const word = stringThrough[ key ];
        if( `${ stringSoFar }${ stringSoFar.length > 0 ? ' ': '' }${ word }`.length <= maxChars ) {
            stringSoFar += stringSoFar.length > 0 ? ' ' + word : word;
            if( key === stringThrough.length - 1 ) {
                breakLine( key );
            }
        } else {
            breakLine( key, word );
        }
    }

    return [ stringLines.join( ' \n' ), stringLines.length ];
  } catch (error) {
    console.log( error );
  }
}